import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';
import { useModal } from 'store/modals';
import { DeleteButton } from 'components/form-elements/buttons/DeleteButton';
import { useDeleteAccessRule } from 'services/2n/access-rules';
import { useAccessManagement2NModal } from '../../../AccessManagement2NModalContext/useAccessManagement2NModal';
import styles from './styles.module.scss';

export const DeleteAccessRule = () => {

  const intl = useIntl();
  const { openModal } = useModal();
  const { selected, updateSelected } = useAccessManagement2NModal();
  const selectedAccessRule = selected.accessRule;
  const { deleteAccessRule, isLoading } = useDeleteAccessRule();

  const selectedAccessRuleId = selectedAccessRule && (selectedAccessRule.Id || selectedAccessRule.id);

  function onDeleteAccessRule() {
    if (!selectedAccessRuleId) return;

    openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        title: intl.formatMessage(
          {
            id: 'deleteAccessRuleConfirm',
          },
        ),
        content: intl.formatMessage(
          {
            id: 'deleteAccessRuleConfirmContent',
          },
        ),
        onConfirm: async () => {
          await deleteAccessRule(selectedAccessRuleId);
          updateSelected('accessRule', null);
        },
      },
    });
  }

  return (
    <DeleteButton
      className={styles.deleteButton}
      intl="deleteAccessRulePermanently"
      disabled={!selectedAccessRuleId || isLoading}
      onClick={() => onDeleteAccessRule()}
    >
      <FormattedMessage id="deleteAccessRulePermanently" />
    </DeleteButton>
   
  );
};
